export default __webpack_public_path__ + "d57a9cb474ae00c7e614786b7b3117b0.png";